/* ==========================================================================
   Gadea Loreak — Carrusel horizontal reutilizable (Home)
   Controla scroll-snap por tarjeta, flechas prev/next, estado disabled en los
   extremos y puntos de paginación. Idempotente: se puede incluir varias veces.
   Contrato DOM:
     [data-iurop-carousel]
       [data-carousel-track]      → contenedor con scroll horizontal
       [data-carousel-prev] / [data-carousel-next]  → botones (opcionales)
       [data-carousel-dot]        → puntos de paginación (opcionales)
   ========================================================================== */
(function () {
  if (window.IuropHomeCarousel) { window.IuropHomeCarousel.initAll(); return; }

  function stepSize(track) {
    var card = track.firstElementChild;
    if (!card) { return track.clientWidth * 0.85; }
    var cs = getComputedStyle(track);
    var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function update(root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) { return; }
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    var max = track.scrollWidth - track.clientWidth - 2;
    /* Regla iUROP: en el origen solo se ve la flecha derecha; tras mover
       aparece la izquierda; al llegar al final desaparece la derecha.
       Se ocultan (hidden), no disabled gris. */
    if (prev) { prev.hidden = track.scrollLeft <= 2; }
    if (next) { next.hidden = track.scrollLeft >= max; }
    var dots = root.querySelectorAll('[data-carousel-dot]');
    if (dots.length) {
      var s = stepSize(track) || 1;
      var idx = Math.round(track.scrollLeft / s);
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
    }
  }

  function go(root, dir) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) { return; }
    track.scrollBy({ left: dir * stepSize(track), behavior: 'smooth' });
  }

  function init(root) {
    if (root.hasAttribute('data-carousel-ready')) { return; }
    root.setAttribute('data-carousel-ready', '');
    var track = root.querySelector('[data-carousel-track]');
    if (!track) { return; }
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (prev) { prev.addEventListener('click', function () { go(root, -1); }); }
    if (next) { next.addEventListener('click', function () { go(root, 1); }); }
    root.querySelectorAll('[data-carousel-dot]').forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        track.scrollTo({ left: stepSize(track) * i, behavior: 'smooth' });
      });
    });
    var raf;
    track.addEventListener('scroll', function () {
      if (raf) { return; }
      raf = window.requestAnimationFrame(function () { raf = null; update(root); });
    }, { passive: true });
    window.addEventListener('resize', function () { update(root); });
    update(root);
  }

  function initAll() {
    document.querySelectorAll('[data-iurop-carousel]').forEach(init);
  }

  window.IuropHomeCarousel = { initAll: initAll };

  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', initAll);
})();
